import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=624a4769&"
import script from "./UserSearch.vue?vue&type=script&lang=ts&"
export * from "./UserSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports